import { PagedResult, Result, UsedItem } from "./../models/index";
import { ServiceBase } from './ServiceBase';

export class SearchIn {
    keywords: string;
    buildingType: string;
    location: string;
    hasRestrooms: boolean;
    areaMin: number;
    areaMax: number;
    sortByField: string;
    culture: string;

    constructor() {
        this.keywords = '';
        this.buildingType = '';
        this.location = '';
        this.hasRestrooms = false;
        this.areaMin = 0;
        this.areaMax = Number.MAX_VALUE;
        this.sortByField = '';
    }

    public static fromInput(input: Partial<SearchIn>) {
        var result = new SearchIn();
        result = { ...result, ...input };
        return result;
    }
}

export class UsedListingService extends ServiceBase {

    public static async search(filters: SearchIn, pageSize: number, offset: number): Promise<Result<PagedResult<UsedItem>>> {

        let searchDto = filters;

        let payload = { ...searchDto, pageSize, offset };

        var result = await this.requestJson<PagedResult<UsedItem>>({
            url: `/api/search/SearchUsed`,
            method: "POST",
            data: payload
        });

        return result;
    }    
}
